import React from 'react'
import PropTypes from 'prop-types'
import * as validators from '../../../validators'
import style from './style'
import Form from '../../../components/Form'
import { Input } from '../../../components/Fields'
import { translations } from '../../../config'

const ResetPasswordForm = Form('reset-password')

const ResetPasswordFormWrapper = ({
  onSubmit,
  errorMessage
}) => {
  return (
    <div>
      <div style={style.generalError}>{errorMessage}</div>
      <ResetPasswordForm onSubmit={onSubmit} submitLabel={translations('SUBMIT')}>
        <Input
          label={translations('New password')}
          name='password'
          type='password'
          style={style.field}
          validate={[validators.password]}
        />
        <div style={style.divider} />
        <Input
          label={translations('Confirm new password')}
          name='passwordConfirmation'
          style={style.field}
          type='password'
          validate={[validators.passwordConfirmation]}
        />
      </ResetPasswordForm>
    </div>
  )
}

ResetPasswordFormWrapper.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string
}

export default ResetPasswordFormWrapper



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordFrom/ResetPasswordForm.js